<template>
  <v-dialog v-model="companyExportModalVisible" max-width="700px" @keydown.enter="addItem" class="ma-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 pa-0">
      <v-container grid-list-md class="pt-2 pb-0 add-product-container">
        <v-row wrap class="">
          <v-col cols="12" class="mt-3">
            <span class="headline">Valitse tuotteet</span>
          </v-col>
          <v-col cols="12" class="pt-2 pb-0">
            <v-autocomplete
              label="Tuotteet"
              class="pa-0 mt-0"
              v-model="productIdsForExport"
              :items="getProducts"
              persistent-hint
              multiple
              hide-details
              item-text="text"
              item-value="id"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-4 mt-10">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2 mr-1" outlined small @click="close">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" outlined small @click="exportContacts" >Export</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import axios from 'axios'
import { ExportToCsv } from 'export-to-csv';
import dateFormat from 'dateformat'

export default {
    props:[],
    data: () => ({
      productIdsForExport:[],
    }),
    watch: {
      
    },
    mounted() {
      
    },

    computed: {
      getProducts(){
        var products = this.products
        var arr = []
        Object.keys(this.products).forEach(function(key, index) {
          var p = products[key]
          if(!p.archived) arr.push({text: p.name.fi, id: p.id} )
        })

        arr = arr.sort((a,b)=>{
          var nameA=a.text.toLowerCase().trim(), nameB=b.text.toLowerCase().trim();
          if (nameA < nameB) {return -1;}
          if (nameB < nameA) {return 1;}
          return 0;
        })  


        return arr
      },
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        user:'user',
        products:"product.products",
        companies:"company.companies",
        contacts:"contact.contacts",
        companyExportModalVisible:"modals.company.export.visible"
      })
    },
    created () {},
    methods: {
      close () {
        this.companyExportModalVisible = false
      },
      async exportContacts(){
        var productIdsForExport = this.productIdsForExport
        var productNames = '['
        productIdsForExport.forEach(pId => {
          if(!this.products[pId]) return
          if(productNames === '[') productNames += this.products[pId].name.fi
          else productNames += ',' +this.products[pId].name.fi
        })
        productNames += ']'
        var data = []
        console.log(this.productIdsForExport)

        
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Exportataan kontakteja...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/logogear-erp/us-central1/exportContacts': 'https://us-central1-logogear-erp.cloudfunctions.net/exportContacts'
          let res = await axios.post(url,
            { productIdsForExport },
          );
          //console.log(res.data.data)

          var latestOrdersByContact = res.data.data

          Object.keys(latestOrdersByContact).forEach(cId => {
            var row = latestOrdersByContact[cId]
            var created_at = row.created_at ? this.customFormatter(row.created_at) : ''

            var comp = this.companies[row.companyId] ? this.companies[row.companyId] : ''
            var con = this.contacts[row.contactId] ? this.contacts[row.contactId] : ''
            var product = this.products[row.productId] ? this.products[row.productId] : ''

            if (comp.companyName.toLowerCase().includes('avecor')) return
            if (con.email.toLowerCase().includes('avecor')) return

            var order = {
              //myyjä: this.staff[comp.salesperson] !== undefined ? this.staff[comp.salesperson].firstName : '',
              tilaus_pvm: created_at,
              netvisorId:row.netvisorId,
              tuote: product ? product.name.fi : '',
              tuotekoodi: product ? product.avecorSku : '',
              yrityksen_nimi: comp ? comp.companyName : '',
              yrityksen_y_tunnus: comp ? comp.companyId : '',
              yrityksen_osoite: comp ? comp.deliveryAddress : '',
              yrityksen_kaupunki: comp ? comp.deliveryCity : '',
              yrityksen_maa: comp ? comp.deliveryCountry : '',
              kontaktin_nimi:con.firstName + ' ' + con.lastName,
              kontaktin_puhelinnumero:con.phone ? con.phone.replace(' ', '') : '',
              kontaktin_sähköpostiosoite:con.email ? con.email.replace(' ', '') : '',
              
            }
            data.push(order)
          })

          const options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            filename:'Kontaktiedot__Tuoterajaus ' + productNames, 
            //showTitle: true,
            //title:name +  'Kontaktitiedot',
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
          };

          if(data.length == 0){
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:'Ei aikasempia tilauksia näillä tuotteilla.', snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }
          else{
          
            const csvExporter = new ExportToCsv(options);
            csvExporter.generateCsv(data);

            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:res.data.message, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          }
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:6000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date._seconds) {
          var myDate = new Date(date._seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/ModalExportContacts.vue